import { render, staticRenderFns } from "./SharesTable.vue?vue&type=template&id=6ce26672&scoped=true&"
import script from "./SharesTable.vue?vue&type=script&lang=js&"
export * from "./SharesTable.vue?vue&type=script&lang=js&"
import style0 from "./SharesTable.vue?vue&type=style&index=0&id=6ce26672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce26672",
  null
  
)

export default component.exports